<template>
  <div class="rank-layer pointer" @click="onClick(item)"  target="_blank">
    <span class="rank-num" :style="isDarkMode ? 'color: white' : 'black'">{{ item.rank }}</span>
    <span class="rank-text" :style="isDarkMode ? 'color: white !important' : ''">{{ item.keyword }}</span>
    <span class="rank-icon" v-if="item.state === '+' || item.state == 'up'"><i class="fi-rr-caret-up" style="color: red"></i></span>
    <span class="rank-icon" v-else-if="item.state === '-' || item.state == 'down'">
      <i class="fi-rr-caret-down" style="color: #0277bd"></i>
    </span>
    <span class="rank-icon" v-else-if="item.state === 's' || item.state == 'equal'" :style="isDarkMode ? 'color: white !important' : ''"
      ><i class="fi-rr-minus-small"></i
    ></span>
    <span class="rank-icon" v-else-if="item.state === 'n'"><i class="fi-rr-plus-small" style="color: burlywood"></i></span>
    <span class="rank-icon" v-else style="color: grey">
      {{ item.state.slice(0, -1) }}<i class="fi-rr-plus-small" style="position: center; color: #0277bd"></i>
    </span>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
export default {
  props: ["item"],
  data() {
    return {
      isMobile: false
    }
  },
  computed: {
    ...mapGetters({ isDarkMode: "isDarkMode" })
  },
  created() {
    this.onResize()
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 768
    },
    onClick(item) {
      if(!item.summary) {
        this.$showToast("AI에서 기사 Summary를 준비중입니다.")
      }
      const url = this.isDarkMode ?  item.summary + `&mode=dark` : item.summary + `&mode=light`
      window.open(url, "_blank")
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixin.scss";
.rank-layer {
  display: flex;
  text-decoration: none;
  :hover {
    background: rgba(0, 0, 0, 0.05);
  }
}
.rank-num {
  font-weight: bold;
  text-align: center;
  width: 20px;
  margin: 5px;
  font-size: 14px;
  @include tablet {
    font-size: 16px;
  }
}

.rank-text {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 6px;
  font-size: 14px;
  @include tablet {
    font-size: 16px;
    width: 80%;
  }
  @include desktop {
    width: 70%;
  }
}
.rank-icon {
  margin-top: 6px;
}
</style>
